var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPcBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12057 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.995392C0 0.445652 0.463996 0 1.03636 0H17.9636C18.536 0 19 0.445652 19 0.995392V11.7788C19 12.3285 18.536 12.7742 17.9636 12.7742H10.6227V16.0092H14.5955C15.1678 16.0092 15.6318 16.4549 15.6318 17.0046C15.6318 17.5543 15.1678 18 14.5955 18H4.57727C4.0049 18 3.54091 17.5543 3.54091 17.0046C3.54091 16.4549 4.0049 16.0092 4.57727 16.0092H8.55V12.7742H1.03636C0.463996 12.7742 0 12.3285 0 11.7788V0.995392ZM2.07273 1.99078V10.7834H16.9273V1.99078H2.07273Z",
    fill: "rgba(0, 0, 0, 0.50)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPcBlack);
export default __webpack_public_path__ + "static/media/ic-pc-black.8977fe787080da5a78e15dec6d55e1d6.svg";
export { ForwardRef as ReactComponent };